import { render, staticRenderFns } from "./BatchAssignTelTask.vue?vue&type=template&id=3a4db88b&scoped=true"
import script from "./BatchAssignTelTask.vue?vue&type=script&lang=js"
export * from "./BatchAssignTelTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4db88b",
  null
  
)

export default component.exports